import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { CustomerBooking } from "rsl-api-106/lib/types";

type WIHPTrackingProps = {
  resa: CustomerBooking;
};

const WIHPTracking: React.FC<WIHPTrackingProps> = ({ resa }) => {
  useEffect(() => {
    var _wic: any = _wic || [];

    const reference = resa?.id;
    const amount = resa?.totalAmount?.amount?.toFixed(2);
    const currency = "EUR";
    const dataformat = "YYYY-MM-DD";
    const startDate = resa?.startDate;
    const endDate = resa?.endDate;

    _wic.push(["_setHotel", resa.property?.id]);
    _wic.push(["_setRef", reference]);
    _wic.push(["_setAmount", amount]);
    _wic.push(["_setCurrency", currency]);
    _wic.push(["_setIDBE", "3"]);
    _wic.push(["_setCheckin", startDate]);
    _wic.push(["_setCheckout", endDate]);
    _wic.push(["_setDateFormat", dataformat]);

    const wh = document.createElement("script");
    wh.type = "text/javascript";
    wh.async = true;
    wh.src =
      ("https:" == document.location.protocol ? "https://" : "http://") +
      "p.relay-t.io/conv.js";

    var s = document.getElementsByTagName("script")[0];
    s.parentNode?.insertBefore(wh, s);
  }, []);

  return <></>;
};

WIHPTracking.propTypes = {
  //
};

export default WIHPTracking;
